import { render, staticRenderFns } from "./ListUsuarios.vue?vue&type=template&id=632c62c3&"
import script from "./ListUsuarios.vue?vue&type=script&lang=js&"
export * from "./ListUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports